











import { Component, Vue, Watch } from 'vue-property-decorator';
import ChannelIdentityPicker from '@/features/bots/components/botTestTool/ChannelIdentityPicker.vue';
import { ChannelIdentityViewModel } from '@/messaging/models/channelIdentityViewModel';
import RestartIcon from 'vue-material-design-icons/Restart.vue';

@Component({
	components: {
		ChannelIdentityPicker,
		RestartIcon
	}
})
export default class ConversationControlBar extends Vue {
	public channelIdentity: ChannelIdentityViewModel = {
		id: 'web-assistant-default',
		type: 'web-assistant',
		name: 'Web Assistant',
		externalId: ''
	};

	@Watch('channelIdentity', { immediate: true })
	public onChannelChange(identity: ChannelIdentityViewModel) {
		this.$emit('channelChanged', identity.type, identity.id);
	}

	public resetButtonClicked() {
		this.$emit('resetClicked');
	}
}
